(()=>{
  const rankings=new Map();
  const loadRanking=path=>{
    const url=new URL(path,location.origin);url.searchParams.set('sort_by','best-selling');url.searchParams.set('section_id','cv-bestseller');
    const theme=new URL(location.href).searchParams.get('preview_theme_id');if(theme)url.searchParams.set('preview_theme_id',theme);
    if(!rankings.has(url.href))rankings.set(url.href,fetch(url,{credentials:'same-origin'}).then(async response=>{if(!response.ok)throw new Error('Ranking unavailable');return new DOMParser().parseFromString(await response.text(),'text/html');}));
    return rankings.get(url.href);
  };
  const initialize=(root=document)=>{
    root.querySelectorAll('[data-cv-default-ranking]:not([data-cv-sort-ready])').forEach(async facet=>{
      facet.dataset.cvSortReady='true';
      const controller=new AbortController(),cancel=()=>controller.abort();
      const timeout=setTimeout(cancel,10000);
      facet.addEventListener('pointerdown',cancel,{once:true});
      facet.addEventListener('keydown',cancel,{once:true});
      try{
        const url=new URL(location.href);
        url.searchParams.set('sort_by','best-selling');
        url.searchParams.set('section_id',facet.getAttribute('section-id'));
        const response=await fetch(url,{credentials:'same-origin',signal:controller.signal});
        if(!response.ok)throw new Error('Collection unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const replacement=doc.querySelector('product-facet');
        if(replacement&&!controller.signal.aborted&&facet.isConnected){
          replacement.dataset.cvSortLoaded='true';
          facet.replaceWith(replacement);
        }
      }catch{/* Keep the usable collection on failure or if the visitor has already interacted. */}
      finally{clearTimeout(timeout);facet.removeEventListener('pointerdown',cancel);facet.removeEventListener('keydown',cancel);}
    });
    root.querySelectorAll('[data-cv-ranked]:not([data-cv-ready])').forEach(async grid=>{
      grid.dataset.cvReady='true';
      try{const doc=await loadRanking(grid.dataset.cvRanked),result=doc.querySelector('[data-cv-best-grid]');if(!result)throw new Error('Ranking unavailable');grid.replaceChildren(...[...result.children].map(node=>node.cloneNode(true)));grid.dataset.cvLoaded='true';}
      catch{/* Preserve the crawlable initial products if the live ranking is unavailable. */}
      finally{grid.setAttribute('aria-busy','false');}
    });
    root.querySelectorAll('product-image-zoom[product-handle="pendente-san"]:not([data-cv-zoom-ready])').forEach(zoom=>{
      zoom.dataset.cvZoomReady='true';
      customElements.whenDefined('product-image-zoom').then(()=>{
        const original=zoom._buildItems.bind(zoom);
        zoom._buildItems=async()=>{const items=await original();return items.map(item=>{
          const img=zoom.closest('product-media').querySelector(`[data-media-id="${item.originalMedia.id}"] img`);
          const src=img?.getAttribute('src');
          return src?.includes('pendente-san-clean-')?{...item,src,msrc:src,w:900,h:900}:item;
        });};
      });
    });
    root.querySelectorAll('product-media[product-handle="arandela-articture"]:not([data-cv-color-ready])').forEach(gallery=>{
      gallery.dataset.cvColorReady='true';const form=document.getElementById(gallery.getAttribute('form-id'));if(!form)return;
      const colors={"Terracota": "arandela-articture-3061285", "Verde": "arandela-articture-2424140", "Branco": "arandela-articture-4851068", "Cinza": "arandela-articture-1684607", "Preto": "arandela-articture-9017050"};
      form.addEventListener('variant:changed',e=>{const filename=colors[e.detail.variant?.option1];if(!filename)return;const thumb=[...gallery.querySelectorAll('.product__thumbnail-item')].find(b=>b.querySelector('img')?.getAttribute('src')?.includes(filename));if(thumb)thumb.click();});
    });

    root.querySelectorAll('[data-cv-discovery]:not([data-cv-ready])').forEach(section=>{
      section.dataset.cvReady='true';
      section.querySelectorAll('[data-cv-filter]').forEach(button=>button.addEventListener('click',()=>{
        section.querySelectorAll('[data-cv-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        section.querySelectorAll('[data-cv-panel]').forEach(panel=>panel.hidden=panel.dataset.cvPanel!==button.dataset.cvFilter);
      }));
    });
    root.querySelectorAll('[data-cv-voices]:not([data-cv-ready])').forEach(section=>{
      section.dataset.cvReady='true';let current=0;const quotes=[...section.querySelectorAll('[data-cv-quote]')];
      const change=delta=>{current=(current+delta+quotes.length)%quotes.length;quotes.forEach((q,i)=>q.toggleAttribute('data-cv-active',i===current));section.querySelector('[data-cv-position]').textContent=`${current+1} / ${quotes.length}`;};
      section.querySelector('[data-cv-previous]').addEventListener('click',()=>change(-1));section.querySelector('[data-cv-next]').addEventListener('click',()=>change(1));
    });
    root.querySelectorAll('[data-cv-best]:not([data-cv-ready])').forEach(async target=>{
      target.dataset.cvReady='true';if(!target.dataset.cvBest)return;
      try{
        const doc=await loadRanking(target.dataset.cvBest),result=doc.querySelector('[data-cv-best-result]');
        if(!result)return;const content=target.dataset.cvMode==='image'?result.querySelector('img'):result.querySelector('a');
        if(content){target.replaceChildren(content.cloneNode(true));target.dataset.cvLoaded='true';}
      }catch{/* Keep the server-rendered product if the request is unavailable. */}
    });

  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
  document.addEventListener('shopify:section:load',e=>initialize(e.target));
})();
